import { Component, Inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AdminService } from '../../services/AdminService/admin';
import { extractErrorMessage } from '../../shared/error-utils';
import { ErrorBanner } from '../../shared/components/error-banner/error-banner';

export interface EditTermMappingDialogData {
  term: string;
  countryCode: string;
  countryLabel: string;
  /** Existing wildcard rule's local name, if a rule already exists. */
  localName: string | null;
  required: boolean;
}

@Component({
  selector: 'app-edit-term-mapping-dialog',
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    ErrorBanner,
  ],
  templateUrl: './edit-term-mapping-dialog.html',
  styleUrl: './edit-term-mapping-dialog.scss',
})
export class EditTermMappingDialog {
  localName: string;
  required: boolean;

  isSubmitting = signal(false);
  errorMessage = signal('');

  constructor(
    private dialogRef: MatDialogRef<EditTermMappingDialog>,
    private admin: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: EditTermMappingDialogData
  ) {
    this.localName = data.localName ?? '';
    this.required = data.required;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  submit(): void {
    this.isSubmitting.set(true);
    this.errorMessage.set('');

    this.admin
      .upsertTermRule(this.data.countryCode, this.data.term, undefined, {
        localName: this.localName.trim() || undefined,
        required: this.required,
        onChain: this.required,
      })
      .subscribe({
        next: () => {
          this.isSubmitting.set(false);
          this.dialogRef.close(true);
        },
        error: (err: HttpErrorResponse) => {
          this.isSubmitting.set(false);
          this.errorMessage.set(extractErrorMessage(err, 'Failed to update the term mapping.'));
        },
      });
  }
}
